@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.default-placeholder {
  height: 100%;
  width: 100%;
  text-align: center;
}

.placeholder-content {
  .vertical-align();
  display: inline-block;
  > div {
    text-align: center;
  }
}

.placeholder-icon {
  height: 100px;
  width: 100px;
  fill: @display-grid--default-placeholder--icon-color;
  margin-bottom: 20px;
}

.placeholder-message {
  color: @display-grid--default-placeholder--text-color;
  font-size: 24px;
}
